<template>
    <section class="mod mod1">
        <!-- <div class="nav2">
      <div class="nav2-wrap flex">
        <span v-for="(nav,i) in bkNavs" :key="i" :class="curBKNav==i?'cur':''" @click="navClick(i)">{{nav}}</span>
      </div>
    </div> -->
        <!--<div class="date-title">
      <span v-if="curBKNav==2"></span>
      <ul class="date-list flex" v-else style="width:80%;">
        <li v-for="(date,i) in dateList" :key="i" :class="curDateIndex==i?'cur':''" @click="riqiSct(i)">{{date}}</li>
      </ul>
      <!~~ <div class="fr date-picker">
        <datepicker :readonly="true" format="YYYY-MM-DD" name="date1" :value="todayDate" :class="todayDate.indexOf('0')>0?'actived':''"></datepicker>
      </div> ~~>
    </div>-->
        <div class="date-title">
            <div class="date-list flex" v-if="timeInfo !== ''">
                更新时间 : {{ timeInfo }}
            </div>
        </div>
        <div class="table-scroll table-scroll-h">
            <div class="table-l fl">
                <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                        <th>板块名称</th>
                    </tr>
                    <tr
                        @click="gotoBk(item.Obj, item.ZhongWenJianCheng)"
                        v-for="(item, index) in topTenList"
                        :key="index"
                    >
                        <td>
                            {{ item.ZhongWenJianCheng
                            }}<small>{{ item.Obj | newCode }}</small>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="table-r">
                <!-- <div class="table-r-wrap" style="width: 4.9rem;" v-if="curBKNav == 0 || curBKNav == 1">
          <table width="100%" cellspacing="0" cellpadding="0">
            <tr><th v-for="(item,index) in jlrbtitle" :key="index">{{item}}</th></tr>
            <tr @click='gotoBk(item.Obj,item.ZhongWenJianCheng)' v-for="(item,index) in topTenList" :key="index">
              <td :class="item.ChiGuZhangFu|formateRedGreen">{{item.ChiGuZhangFu}}%</td>
              <td :class="item.ChiGuShiZhiBianHua|formateRedGreen">{{item.ChiGuShiZhiBianHua| getbh}}</td>
              <td>{{item.ZhanLiuTongGuBiLiBianHua| bfbNum}}%</td>
            </tr>
          </table>
        </div> -->

                <!-- 重仓 -->
                <div class="" v-if="curBKNav == 2">
                    <table width="100%" cellspacing="0" cellpadding="0">
                        <tr>
                            <th v-for="(item, index) in zcbtitle" :key="index">
                                {{ item }}
                            </th>
                        </tr>
                        <tr v-for="(item, index) in topTenList" :key="index">
                            <td>
                                {{ item.ChiGuShiZhi
                                }}<span v-if="item.ChiGuShiZhi > 0">亿</span>
                            </td>
                            <!-- <td>{{item.ZhanLiuTongGuBiLiBianHua}}%</td> -->
                            <td :class="item.ChiGuZhangFu | formateRedGreen">
                                {{ item.ChiGuZhangFu }}%
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div
                v-if="GdShow"
                style="text-align: center; padding: 15px 10px"
                @click="bkGengduo()"
            >
                点击加载更多
            </div>
        </div>
    </section>
</template>

<script>
// import datepicker from 'vue-date-picker'
import { bklist } from "@/api/int.js";

export default {
    name: "BanKuai",
    components: {
        // datepicker
    },
    data() {
        return {
            GdShow: true,
            curBKNav: 2,
            bkNavs: ["净流入", "净流出", "重仓"],
            topTenList: [],
            todayDate: "自定义日期",
            curDateIndex: 0,
            dateList: ["当日", "近5日", "近20日", "近60日", "近120日"],
            riqiNum: ["1", "5", "20", "60", "120"],
            block: "股票/大智慧自定义/行业板块",
            day: -1,
            orderby: "ChiGuShiZhi",
            pagesize: 10,
            page: 1,
            jlrbtitle: ["区间涨幅", "净流入额", "占流通股比"],
            zcbtitle: ["持股市值", "涨跌幅"],
            timeInfo: "",
            // desc:true,
        };
    },
    mounted: function () {
        this.getList();
    },
    methods: {
        getList: function () {
            var start = (this.page - 1) * this.pagesize + 1;

            bklist({
                block: this.block,
                day: this.day,
                orderby: this.orderby,
                count: this.pagesize,
                start: start,
                desc: this.desc,
            }).then((res) => {
                //this.topTenList = res.data.data.list;
                if (res.data.err == 0) {
                    if (
                        res.data.data.list.length < this.pagesize ||
                        res.data.data.list.length == 0
                    ) {
                        this.GdShow = false;
                    }
                    res.data.data.list.forEach((element) => {
                        this.topTenList.push(element);
                    });
                    this.page = this.page + 1;
                    this.timeInfo = res.data.data.time;
                }
            });
        },

        bkGengduo: function () {
            this.getList();
        },
        riqiSct: function (i) {
            this.block = "股票/大智慧自定义/行业板块";

            this.page = 1;

            this.curDateIndex = i;
            this.day = this.riqiNum[i];
            this.orderby = "ChiGuShiZhiBianHua" + this.riqiNum[i];
            if (this.riqiNum[i] == 1) {
                this.orderby = "ChiGuShiZhiBianHua1";
                this.day = -1;
            }
            this.topTenList = [];
            this.getList();
        },
        gotoBk: function (code, name) {
            // code = code.slice(2);
            location.href =
                window.location.protocol +
                "//" +
                window.location.host +
                window.location.pathname +
                "#/bkdetail?code=" +
                code +
                "&DZHSPECIAL=264&name=" +
                name;
            // this.$router.push('/bkdetail?code='+code+'&DZHSPECIAL=264&name='+name);
        },
        navClick: function (i) {
            this.GdShow = true;
            if (i == 0 && i != this.curBKNav) {
                this.day = -1;
                this.curDateIndex = 0;
                this.topTenList = [];
                this.page = 1;
                this.desc = true;
                this.orderby = "ChiGuShiZhiBianHua1";
                this.block = "股票/大智慧自定义/行业板块";
                this.getList();
            } else if (i == 1 && i != this.curBKNav) {
                this.day = -1;
                this.curDateIndex = 0;
                this.topTenList = [];
                this.page = 1;
                this.desc = false;
                this.orderby = "ChiGuShiZhiBianHua1";
                this.block = "股票/大智慧自定义/行业板块";
                this.getList();
            } else if (i == 2 && i != this.curBKNav) {
                this.day = -1;
                this.curDateIndex = 0;
                this.topTenList = [];
                this.page = 1;
                this.desc = true;
                this.orderby = "ChiGuShiZhi";
                this.block = "股票/大智慧自定义/行业板块";
                this.getList();
            }

            this.curBKNav = i;
        },
    },
    filters: {
        newCode: function (v) {
            return v.slice(2);
        },
        formateTag: function (v) {
            if (v == undefined || v == null) return;
            if (v > 0) return "交易中";
            if (v < 0) return "已结束";
        },
        formatePrefixData: function (v) {
            if (v == undefined || v == null) return "--";
            if (v > 0) return "+" + v;
            if (v < 0) return v;
        },
        formateRedGreen: function (v) {
            if (v == undefined || v == null) return;
            if (v > 0) return "ft-red";
            if (v < 0) return "ft-green";
        },
        getbh: function (v) {
            //v 单位万元
            if (Math.abs(v) < 10000 && Math.abs(v) > 0) {
                return v.toFixed(2) + "万";
            } else if (Math.abs(v) >= 10000) {
                return (v / 10000).toFixed(2) + "亿";
            } else {
                return "0";
            }
        },
        bfbNum: function (v) {
            if (v == 0) {
                return "0.00";
            } else {
                return v;
            }
        },
    },
};
</script>
